import { Label, Popup } from './';
import { colorByGender } from './common';

import React from 'react';
import PropTypes from 'prop-types';

const GroupLabel = ({ group, meta, ...props }) => {
  const { isOnlyGroup, contest, letter } = group;
  const { bodyweightCategory, ageGroup } = contest;

  return (
    <Popup
      trigger={
        <Label color={colorByGender(ageGroup.gender)} {...props}>
          {bodyweightCategory.abbreviation}
          <Label.Detail>{ageGroup.abbreviation}</Label.Detail>
          {isOnlyGroup || <Label.Detail>{letter}</Label.Detail>}
        </Label>
      }
    >
      {ageGroup.title} {bodyweightCategory.title}
      {isOnlyGroup || ` ${letter}-group`}
    </Popup>
  );
};

GroupLabel.propTypes = {
  group: PropTypes.shape({
    contest: PropTypes.shape({
      title: PropTypes.string.isRequired,
      groups: PropTypes.arrayOf(
        PropTypes.shape({
          letter: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }).isRequired,
  }).isRequired,
};

export default GroupLabel;



// WEBPACK FOOTER //
// ./src/components/GroupLabel.js